import { gsap } from "gsap";
import { GlowFilter } from "pixi-filters";
import { Container, IDestroyOptions, Sprite } from "pixi.js";
import { UnboardingResourcePackage } from "../../resources/UnboardingResourcePackage";
import { CurrentViewPointerType } from "./CurrentViewPointerType";
import { FirstSector } from "./sectors/FirstSector";
import { SecondSector } from "./sectors/SecondSector";
import { ThirdSector } from "./sectors/ThirdSector";

export class UnboardingCurrentViewPointer extends Container {
    private readonly unboardingResources: UnboardingResourcePackage;

    private frame: Sprite;
    private firstSector: FirstSector;
    private secondSector: SecondSector;
    private thirdSector: ThirdSector;
    private selector: Sprite;
    private selectorMoveAnimationTimeLine: gsap.core.Timeline;

    public constructor(unboardingResources: UnboardingResourcePackage) {
        super();
        this.unboardingResources = unboardingResources;
        this.selectorMoveAnimationTimeLine = new gsap.core.Timeline({ paused: true });
        this.build();
    }

    private build(): void {
        this.frame = new Sprite(this.unboardingResources.assets_views_unboarding_sequence_frame_png);
        this.addChild(this.frame);
        this.firstSector = new FirstSector(this.unboardingResources);
        this.firstSector.position.set(8, 12);
        this.addChild(this.firstSector);
        this.secondSector = new SecondSector(this.unboardingResources);
        this.secondSector.position.set(236, 11);
        this.addChild(this.secondSector);
        this.thirdSector = new ThirdSector(this.unboardingResources);
        this.thirdSector.position.set(474, 11);
        this.addChild(this.thirdSector);
        this.setFiltersOnSectors();
        this.selector = new Sprite(this.unboardingResources.assets_views_unboarding_selector_png);
        this.selector.position.set(46, -81.5);
        this.addChild(this.selector);
    }

    public async showSelectedView(pointerType: CurrentViewPointerType): Promise<void> {
        switch (pointerType) {
            case CurrentViewPointerType.FIRST:
                this.selectorMoveAnimationTimeLine.to(this.selector, { x: 46, duration: 1, ease: "back.out(1)" });
                await this.selectorMoveAnimationTimeLine.play();
                this.selectorMoveAnimationTimeLine.clear();
                this.firstSector.showFilters();
                break;
            case CurrentViewPointerType.SECOND:
                this.firstSector.hideFilters();
                this.selectorMoveAnimationTimeLine.to(this.selector, { x: 292, duration: 1, ease: "back.out(1)" });
                await this.selectorMoveAnimationTimeLine.play();
                this.selectorMoveAnimationTimeLine.clear();
                this.secondSector.showFilters();
                break;
            case CurrentViewPointerType.THIRD:
                this.secondSector.hideFilters();
                this.selectorMoveAnimationTimeLine.to(this.selector, { x: 543, duration: 1, ease: "back.out(1)" });
                await this.selectorMoveAnimationTimeLine.play();
                this.selectorMoveAnimationTimeLine.clear();
                this.thirdSector.showFilters();
                break;
        }
    }

    private setFiltersOnSectors(): void {
        this.firstSector.setFilters(new GlowFilter({ distance: 5, outerStrength: 2, innerStrength: 0, color: 0xFF6E0E, quality: 0.1, alpha: 1 }), new GlowFilter({ distance: 5, outerStrength: 0, innerStrength: 1, color: 0xFFD600, quality: 0.1, alpha: 1 }));
        this.secondSector.setFilters(new GlowFilter({ distance: 5, outerStrength: 2, innerStrength: 0, color: 0xFF6E0E, quality: 0.1, alpha: 1 }), new GlowFilter({ distance: 5, outerStrength: 0, innerStrength: 1, color: 0xFFD600, quality: 0.1, alpha: 1 }));
        this.thirdSector.setFilters(new GlowFilter({ distance: 5, outerStrength: 2, innerStrength: 0, color: 0xFF6E0E, quality: 0.1, alpha: 1 }), new GlowFilter({ distance: 5, outerStrength: 0, innerStrength: 1, color: 0xFFD600, quality: 0.1, alpha: 1 }));
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.selectorMoveAnimationTimeLine.kill();
        super.destroy(options);
    }
}